import { useState } from 'react';
import { RefreshCw, LogOut, AlertCircle } from 'lucide-react';
import { Button } from './ui/button';

// Controllo piano non riuscito: muro neutro, mai "prova scaduta" (potrebbe essere un cliente pagante)
export const PlanCheckFailedWall = ({ onRetry, onLogout }) => {
  const [retrying, setRetrying] = useState(false);

  const retry = async () => {
    setRetrying(true);
    try {
      await onRetry();
    } finally {
      setRetrying(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[10000] bg-[#FAF9F6] flex items-center justify-center p-6" data-testid="plan-check-failed-wall">
      <div className="max-w-sm text-center">
        <AlertCircle className="w-14 h-14 text-[#64748B] mx-auto mb-4" />
        <p className="text-xl font-bold text-[#2C3E50] mb-2">Non siamo riusciti a verificare il tuo piano</p>
        <p className="text-[#64748B] mb-6">Riprova tra qualche istante.</p>
        <div className="flex flex-col gap-3">
          <Button onClick={retry} disabled={retrying} className="bg-[#2C3E50] hover:bg-[#1F2D3A] text-white" data-testid="plan-check-retry">
            <RefreshCw className={`w-4 h-4 mr-2 ${retrying ? 'animate-spin' : ''}`} />
            Riprova
          </Button>
          <Button onClick={onLogout} variant="outline" data-testid="plan-check-logout">
            <LogOut className="w-4 h-4 mr-2" />
            Esci
          </Button>
        </div>
      </div>
    </div>
  );
};
